import { styled } from '@mui/material'
import { ZKEX_APP_V2_URL, isTestnet } from 'config'
import { Link } from 'react-router-dom'
import { Flex } from 'styles'

const VerisonWrap = styled(Flex)`
  border: 1px soldi;
  border-radius: 6px;
  display: flex;
  gap: 4px;
  height: 36px;
  align-items: center;
  transition: background ease-in-out 0.3s;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.color.bgLightGray};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

const StyldeV2 = styled(Link)`
  color: ${(props) => props.theme.color.text60};
  font-size: 16px;
  height: 34px;
  width: 34px;
  background-color: transparent;
  display: inline-block;
  text-align: center;
  line-height: 34px;
`

const StyldeV3 = styled('a')`
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 16px;
  height: 34px;
  width: 34px;
  font-weight: 600;
  background-color: rgba(175, 191, 202, 0.2);
  display: inline-block;
  text-align: center;
  line-height: 34px;
`

export const VersionSwitch = () => {
  if (isTestnet) {
    return null
  }
  return (
    <VerisonWrap>
      <StyldeV2 to={'/v2/withdrawal'} target="_blank">
        V2
      </StyldeV2>
      <StyldeV3 href="javascripit:void(0)">V3</StyldeV3>
    </VerisonWrap>
  )
}
